import { render, staticRenderFns } from "./BoxQueueTrendAnalysis.vue?vue&type=template&id=36ec40ed&"
import script from "./BoxQueueTrendAnalysis.vue?vue&type=script&lang=js&"
export * from "./BoxQueueTrendAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./BoxQueueTrendAnalysis.vue?vue&type=style&index=0&id=36ec40ed&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QIcon,QTooltip,QSelect,QInnerLoading,QSpinnerTail} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QIcon,QTooltip,QSelect,QInnerLoading,QSpinnerTail})
